module.exports = __webpack_public_path__ + "adac70405a012afba07c474898f83d2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/one_page_slide_Pixel-Forest-2016.jpg
// module id = 226
// module chunks = 0